import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledInputCount = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .input-count {
    border: ${(props) =>
      props.isError && `1px solid ${COLOR.functionalRed.default}`};
  }
  .title-input {
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 6px;
  }
  .row-input {
    display: flex;
    height: 40px;
  }
  .input-count {
    padding: 12px 16px;
    border: none;
    border-radius: 12px;
    display: flex;
    align-items: center;
    flex: 1;
    background: ${COLOR.charcoal};
    input {
      outline: none;
      border: none;
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      font-family: 'SF Pro', sans-serif;
      background: ${COLOR.charcoal};
    }
    .count-text {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-left: 8px;
      color: ${COLOR.label2[48]};
    }
  }

  .msg-error {
    color: ${COLOR.functionalRed.default};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
`;

export const StyledReferralRule = styled('div')`
  .rule-referral-code {
    color: ${COLOR.label2[48]};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
`;
